import { gql } from '@apollo/client';

import { HOMEWORK_SUBMISSION_FIELDS } from '../fragments/homeworks';

/**
 * Spec 0012 (homework submissions) — ERP-scope read-only queries. Operation
 * names deliberately differ from the backend field names
 * (`groupHomeworkOverviewForErp`, `lessonHomeworkSubmissionsForErp`, …) to
 * avoid the codegen result-type collapse.
 *
 * Wire conventions (0009–0011): statuses/kind are plain Strings —
 * `hwMark` ∈ done|contains_errors|not_done|null, submission `status` ∈
 * submitted|graded, `aiReview.status` ∈ pending|fetching|analyzing|done|failed.
 */

export const GroupHomeworkOverviewQuery = gql`
  query ErpGroupHomeworkOverview($groupId: ID!) {
    groupHomeworkOverviewForErp(groupId: $groupId) {
      lessonId
      hasAssignment
      totalStudents
      submittedCount
      gradedCount
      aiDoneCount
      suspiciousCount
    }
  }
`;

export const LessonHomeworkSubmissionsQuery = gql`
  ${HOMEWORK_SUBMISSION_FIELDS}
  query ErpLessonHomeworkSubmissions($lessonId: ID!) {
    lessonHomeworkSubmissionsForErp(lessonId: $lessonId) {
      studentId
      studentName
      hwMark
      submission {
        ...HomeworkSubmissionFields
      }
    }
  }
`;

export const StudentHomeworkQuery = gql`
  ${HOMEWORK_SUBMISSION_FIELDS}
  query ErpStudentHomework($studentId: ID!) {
    studentHomeworkForErp(studentId: $studentId) {
      groupId
      groupName
      lessonId
      lessonName
      assignmentTitle
      hwMark
      submission {
        ...HomeworkSubmissionFields
      }
    }
  }
`;

/**
 * Short-lived presigned GET for a ZIP submission. Fetched lazily (via
 * `client.query`, `network-only`) right before `window.open` — never cached,
 * a stale presigned URL is a broken link.
 */
export const HomeworkSubmissionDownloadUrlQuery = gql`
  query ErpHomeworkSubmissionDownloadUrl($submissionId: ID!) {
    homeworkSubmissionDownloadUrlForErp(submissionId: $submissionId)
  }
`;
